import { render, staticRenderFns } from "./quickActions.vue?vue&type=template&id=80e23600&scoped=true"
import script from "./quickActions.vue?vue&type=script&lang=js"
export * from "./quickActions.vue?vue&type=script&lang=js"
import style0 from "./quickActions.vue?vue&type=style&index=0&id=80e23600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e23600",
  null
  
)

export default component.exports